import { useAuth } from "@/contexts/AuthContext";

/**
 * Returns the destination for "Try the Learning Buddy" / chat CTAs.
 * - Signed-in users → /chat
 * - Logged-out users → /auth?redirect=/chat (signup-first flow)
 */
export function useChatCtaHref(): string {
  const { user } = useAuth();
  return user ? "/chat" : "/auth?redirect=/chat";
}
